import { computed, observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import { autobind } from 'core-decorators';
import routeConfigs from '@src/pages/app-router/route-configs';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import { useEffect } from 'react';

class FooterStore extends BaseStore {
  @observable showQrCode = false;

  @observable oversea = document.documentElement.lang !== 'zh-Hans';
  @observable layerData = null;

  @computed
  get bottomLinkGroup() {
    const bottomInfo = this.layerData?.bottom_info;
    const links = [];
    if (bottomInfo?.private_title) {
      links.push({ title: bottomInfo.private_title, link: bottomInfo.private_link });
    }
    if (bottomInfo?.agreement_title) {
      links.push({ title: bottomInfo.agreement_title, link: bottomInfo.agreement_link });
    }
    if (bottomInfo?.anti_addiction_title) {
      links.push({ title: bottomInfo.anti_addiction_title, link: bottomInfo.anti_addiction_link });
    }
    if (bottomInfo?.crime_report_title) {
      links.push({ title: bottomInfo.crime_report_title, link: bottomInfo.crime_report_link });
    }
    return links;
  }

  @autobind
  redirectIndex() {
    this.redirect(routeConfigs.MAIN.getFormatPath());
    document.scrollingElement.scrollTop = 0;
  }
  scrollToTop = anchorName => {
    if (anchorName) {
      let anchorElement = document.getElementById(anchorName);
      if (anchorElement) {
        anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  };

  onMouseoverState = () => {
    this.showQrCode = true;
  };

  onMouseleaveState = () => {
    this.showQrCode = false;
  };

  use() {
    super.use();

    const layerData = useLayerData('footer');
    const pageConfig = useLayerData('pageConfig');
    console.log(pageConfig, layerData, 'pageConfig,layerData');

    useEffect(
      () => {
        this.layerData = layerData;
      },
      [layerData]
    );

    useEffect(
      () => {
        // 再次确认不是国内站
        if (pageConfig?.language && this.oversea) {
          this.oversea = pageConfig.language !== '简体中文';
        }
      },
      [pageConfig?.language]
    );
  }
}

export default FooterStore;
